import { Text } from "@repo/components/src/ui/text";
import React from "react";
import SharedProfileNiches from "../../shared/niches";
import { ProfileBodyProps } from "../../types";

const ProfileNiches = React.memo((props: ProfileBodyProps) => {
  const { user } = props;
  const userFields = user;
  if (!user.usernicheSet.length)
    return (
      <Text action="muted">
        {userFields.firstName} no ha vinculado sus nichos con Montu.
      </Text>
    );
  return <SharedProfileNiches userNicheSet={user.usernicheSet} />;
});

ProfileNiches.displayName = "ProfileNiches";

export default ProfileNiches;
